import script from "./SharedOffcanvasApp.vue?vue&type=script&setup=true&lang=js"
export * from "./SharedOffcanvasApp.vue?vue&type=script&setup=true&lang=js"

import "./SharedOffcanvasApp.vue?vue&type=style&index=0&id=f18c42d4&lang=scss"

const __exports__ = script;

export default __exports__